// Minimal notify helper for beta: dispatches toast events.
import { showToast } from './toast';

export function showError(message) {
  try {
    showToast('error', message);
    return;
  } catch {
    // fallback to console
  }
  console.error('Error:', message);
}

export function showInfo(message) {
  try {
    showToast('info', message);
    return;
  } catch {
    // fallback to console
  }
  console.log('Info:', message);
}

export default { showError, showInfo };
